<mat-form-field class="w-full" [appearance]="appearance()">
  <mat-label>{{ label() }}</mat-label>
  <mat-chip-grid #chipGrid aria-label="Option selection"> @for (selected of selectedOptions; track selected) { 
    <mat-chip-row [removable]="true" (removed)="removeOption(selected)">
      <span>{{ prefix() + selected | uppercase | translate }}</span>
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row> } 
  </mat-chip-grid>
  <input matInput #autoCompleteChipInput [placeholder]="placeholder()" [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="[]" [matChipInputAddOnBlur]="false" [formControl]="inputControl" [matAutocomplete]="auto" (focus)="focusInput()" />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectOption($event)"> @for (option of filteredOptions | async; track $index) { <mat-option [value]="option"> {{ prefix() + option | uppercase | translate }} </mat-option> } </mat-autocomplete>
</mat-form-field>